import React, {useCallback, useMemo, useState} from 'react';

import type {AppContextState, SetAppContext} from '../types';

import {AppContext} from './app.context';

const initialAppContext = {
    isOnStepByStepJoinScreen: false,
};

export const AppContextProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [appContext, setAppContextInternal] =
        useState<AppContextState>(initialAppContext);

    const setAppContext = useCallback<SetAppContext>((key, updater) => {
        setAppContextInternal(prevState => {
            const newValue = updater(prevState[key]);
            return {...prevState, [key]: newValue};
        });
    }, []);

    const contextValue = useMemo(
        () => ({appContext, setAppContext}),
        [appContext, setAppContext],
    );

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};
